module.exports = __webpack_public_path__ + "assets/img/16_1740.d7d8ce98.jpg";